import axios from "axios";
import {API} from "../config";

const path = "/voluntariados";
const subPath = "/servico-acolhimento";

class VoluntariadoSAService {
  novoVoluntarioSA(id, voluntarioSA){
    let formData = new FormData();

    for ( let key in voluntarioSA ) {
      formData.append(key, voluntarioSA[key]);
    }
    return axios.post(API + path + subPath + `/${id}`, formData);
  }

  getVoluntariosSA(id){
    return axios.get(API + path + subPath + `/${id}`)
  }

  atualizarVoluntarioSA(id, voluntarioSA){
    let formData = new FormData();

    for ( let key in voluntarioSA ) {
      formData.append(key, voluntarioSA[key]);
    }
    return axios.put(API + path + `/${id}`, formData);
  }

  getVoluntario(id){
    return axios.get(API + path + `/${id}`)
  }

  listarVoluntarios(){
    return axios.get(API + path)
  }

  desligarVoluntarioSA(id, dataDesligamento){
    return axios.post(API + path + `/desligar/${id}`, {}, {
      params: {
        dataDesligamento
      }
    });
  }
}

const instanceVoluntariadoSA = new VoluntariadoSAService();
export default instanceVoluntariadoSA;